// extracted by mini-css-extract-plugin
module.exports = {"headingWrapper":"help_headingWrapper__0eXZ5","textWrapper":"help_textWrapper___I_ey"};